import Vue from 'vue'
import Vuex from 'vuex'
import { LoginWechat } from '../api/user'
// import Cookies from 'js-cookie'
import { SetGetAuthInfo } from '../util/auth'
import { GetInsurancePlanDetail } from '../api/insu-info'
import { ObjectArraySort, getDeviceInfo } from '../util/tools'

Vue.use(Vuex)

const DeviceInfo = getDeviceInfo()
export const store = new Vuex.Store({
  state: {
    wxConfigInfo: {},
    deviceInfo: DeviceInfo,
    userInfo: {},
    curInsuProdInfo: {},
    productStatus: ''
  },
  getters: {
    userInfo: state => {
      return state.userInfo
    },
    insuProdInfo: state => {
      return state.curInsuProdInfo
    },
    productStatus: state => {
      return state.productStatus
    }
  },
  mutations: {
    SET_USER_INFO: (state, payload = {}) => {
      state.userInfo = Object.assign({}, state.userInfo, payload)
    },
    SET_WX_CONFIG_INFO: (state, payload) => {
      state.wxConfigInfo = payload
    },
    SET_INSU_INFO: (state, payload = {}) => {
      state.curInsuProdInfo = payload
    },
    SET_PRODUCT_STATUS: (state, val) => {
      state.productStatus = val
    }
  },
  actions: {
    async getUserToken({ commit }, payload = {}) {
      const res = await LoginWechat(payload)
      const { token, mobilePhone } = res
      SetGetAuthInfo.setInfo({ token, mobilePhone })
      commit('SET_USER_INFO', { token, mobilePhone })
      localStorage.setItem('wxinfor',JSON.stringify(res))
      // console.log('get token -- userInfo', state.userInfo)
    },
    async getInsuDetail({ commit }, payload) {
      const res = await GetInsurancePlanDetail({ insurancePlanId: payload })
      res.detailImgList = []
      res.clauseFileList = []
      res.serviceFileList = []
      res.detailOtherFiles = []
      res.buyInfoOtherFiles = []
      res.listShowImg = {}
      if (res.attrFileList) {
        res.attrFileList.forEach(item => {
          item.name = item.attrName
          item.url = item.showFileUrl
          item.text = item.attrName
          switch (item.productAttrType) {
            case 'LIST_PIC':
              // 列表展示图
              res.listShowImg = item
              break
            case 'MAIN_PIC':
              // 主题图
              res.mainImg = item
              break
            case 'DETAILS_SHOW_PIC':
              // 详情图
              res.detailImgList.push(item)
              break
            case 'INSURANCE_CLAUSE_FIlE':
              // 保险条款
              res.clauseFileList.push(item)
              break
            case 'SERVICE_ADVANTAGES':
              // 服务优势
              res.serviceFileList.push(item)
              break
            case 'INSTRUCTIONS_TEXT':
              res.xuZhiFile = item
              break
            default:
              if (item.displayPosition === 'plan_detail') {
                res.detailOtherFiles.push(item)
              } else if (item.displayPosition === 'insured') {
                res.buyInfoOtherFiles.push(item)
              } else if (item.displayPosition === 'all') {
                res.detailOtherFiles.push(item)
                res.buyInfoOtherFiles.push(item)
              }
          }

          // if (item.productAttrType === 'MAIN_PIC') {
          //   res.mainImg = item
          // }
          // if (item.productAttrType === 'DETAILS_SHOW_PIC') {
          //   // 详情图
          //   res.detailImgList.push(item)
          // }
          // // 保险条款
          // if (item.productAttrType === 'INSURANCE_CLAUSE_FIlE') {
          //   res.clauseFileList.push(item)
          // }
          // // 服务优势
          // if (item.productAttrType === 'SERVICE_ADVANTAGES') {
          //   res.serviceFileList.push(item)
          // }
          // // 投保须知 INSTRUCTIONS_TEXT
          // if (item.productAttrType === 'INSTRUCTIONS_TEXT') {
          //   res.xuZhiFile = item
          // }
          // // 提示书
          // if (item.productAttrType === 'INSURANCE_ADVICE') {
          //   res.tiShiFile = item
          // }
          // // 服务
          // if (item.productAttrType === 'INSURANCE_SERVICE_AGREEMENT') {
          //   res.fuWuXieYiFile = item
          // }
          // // 续保
          // if (item.productAttrType === 'AUTOMATIC_RENEWAL') {
          //   res.xuBaoFile = item
          // }
        })
      }
      res.clauseFileList.sort(ObjectArraySort('sort', true))
      res.serviceFileList.sort(ObjectArraySort('sort', true))
      res.detailImgList.sort(ObjectArraySort('sort', true))
      res.detailOtherFiles.sort(ObjectArraySort('sort', true))
      res.buyInfoOtherFiles.sort(ObjectArraySort('sort', true))
      if (res.securityRegulations) {
        res.baoZhangList = JSON.parse(res.securityRegulations)
      }
      commit('SET_INSU_INFO', res)
    }
  }
})
